import ActionTypes from "./ActionTypes";

const getChats = payload => {
    return {
        type: ActionTypes.GET_CHATS,
        payload,
    };
}

const clearChats = () => {
    return {
        type: ActionTypes.CLEAR_CHATS,
    };
}


const updateChats = payload => {
    return {
        type: ActionTypes.UPDATE_CHATS,
        payload,
    };
}
export {
    getChats,
    clearChats,
    updateChats,
};